/* RANI CUSTOM — Search placeholder rotation
   data-rani-search-rotate="Term1|Term2|Term3..."
   Kullanıcı input'a tıklamadığı sürece placeholder belli aralıkla değişir.
*/
(function () {
  'use strict';

  function initRotation(input) {
    var raw = input.getAttribute('data-rani-search-rotate');
    if (!raw) return;
    var items = raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (items.length < 2) return;

    var idx = 0;
    var paused = false;
    var intervalMs = 2200;

    function rotate() {
      if (paused) return;
      idx = (idx + 1) % items.length;
      input.setAttribute('placeholder', items[idx]);
    }

    var timer = setInterval(rotate, intervalMs);

    input.addEventListener('focus', function () {
      paused = true;
    });
    input.addEventListener('blur', function () {
      paused = false;
    });
  }

  function init() {
    var inputs = document.querySelectorAll('[data-rani-search-rotate]');
    inputs.forEach(initRotation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
